import React from 'react';

import './News.css';
import Marquee from './Components/Marquee/Marquee';
import NewsList from './Components/NewsList/NewsList';
import NewsContact from './Components/NewsContact/NewsContact';
function News() {
  return (
    <div className="news-page">
      <Marquee/>
      {/* <div className="spacer height-s"></div> */}
      <NewsList />
      {/* <div className="spacer height-l"></div> */}
      <NewsContact />
      {/* <div className="spacer height-l"></div> */}
    </div>
  );
}

export default News;